import { Injectable } from '@angular/core';

import { ApiApplication } from '@careconne/core/configs';

import { ApiService } from '../common';

@Injectable()
export class DaiPublicService {
  constructor(private readonly http: ApiService) {}

  getNoteGraphList(param: any) {
    return this.http.post(ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.NOTE_GRAPH_LIST, param);
  }

  getNoteList(param: any) {
    return this.http.post(ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.NOTE_LIST, param);
  }

  getNoteListStepFunction(param: any) {
    return this.http.post(
      ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.NOTE_LIST_STEP_FUNCTION,
      param,
    );
  }

  updateStepFunctionByDaicd(param: any) {
    return this.http.post(
      ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.UPDATE_STEP_FUNCTION_BY_DAICD,
      param,
    );
  }

  getIdStepFunctionByDaicd(param: any) {
    return this.http.post(
      ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.GET_ID_STEP_FUNCTION_BY_DAICD,
      param,
    );
  }

  getNoteListBySelectedDate(param: any) {
    return this.http.post(
      ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.NOTE_LIST_BY_SELECTED_DATE,
      param,
    );
  }

  resetDataByDaicd(daicd: string) {
    return this.http.post(ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.RESET_DATA_BY_DAI_SELECTED, {
      daicd,
    });
  }

  resetDataRecordListByCompanyid(isGraphTitle = false) {
    return this.http.post(ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.RESET_DATA_RECORD_LIST, {
      isGraphTitle,
    });
  }

  getTitleTagDataBySelectedDate(param: any) {
    return this.http.post(
      ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.TITLE_TAG_DATA_BY_SELECTED_DATE,
      param,
    );
  }

  getDaiListByCkPassRole(data: { userId: number; roleId: number }) {
    return this.http.post(ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.GET_LIST_DAI_BY_ROLE, data);
  }

  downloadImageFromS3(fileName: string) {
    return this.http.post(ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.DOWNLOAD_IMAGE_FROM_S3, {
      fileName,
    });
  }
}
